import styled, { css } from 'styled-components'

import { Link } from '@ui/links/Link'

export const StyledOrangeLink = styled(Link)`
  ${({ theme, fontSize, $mobileFontSize, fontWeight, $inherit }) =>
    $inherit
      ? css`
          font-size: inherit;
          font-weight: inherit;
          line-height: inherit;
        `
      : css`
          font-size: ${theme.fontSizes[fontSize]}px;
          font-weight: ${theme.fontWeight[fontWeight]};
          line-height: ${({ theme }) => theme.lineHeight[7]}px;
          ${({ theme }) => css`
            ${theme.below.mobileXL`
               font-size: ${
                 $mobileFontSize
                   ? `${theme.fontSizes[$mobileFontSize]}px`
                   : `${theme.fontSizes[fontSize]}px`
               };
            `}
          `}
        `}

  color: ${({ theme }) => theme.colors.primary};
  word-wrap: break-word;

  &:hover {
    text-decoration: underline;
  }
`
